import { buttonClasses } from "@mixitone/components/Styles/Buttons";
import { isStaleAssetError, tryRecoverStaleAsset } from "@mixitone/util";
import { useEffect } from "react";
import { Link, isRouteErrorResponse, useRouteError } from "react-router-dom";

export function RouteErrorPage() {
  const error = useRouteError();

  useEffect(() => {
    tryRecoverStaleAsset(error);
  }, [error]);

  if (isStaleAssetError(error)) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-center text-slate-200">
        Updating…
      </div>
    );
  }

  let title = "Something went wrong";
  let details = "We hit an unexpected issue while loading this page.";

  if (isRouteErrorResponse(error)) {
    title = error.status === 404 ? "Page not found" : `Error ${error.status}`;
    if (typeof error.data === "string" && error.data.trim().length > 0) {
      details = error.data;
    } else if (error.statusText) {
      details = error.statusText;
    }
  } else if (error instanceof Error && error.message) {
    details = error.message;
  }

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-2xl font-semibold text-white">{title}</h1>
      <p className="max-w-xl text-slate-200">{details}</p>
      <div className="flex gap-3">
        <button
          type="button"
          className={buttonClasses({ kind: "secondary" })}
          onClick={() => window.location.reload()}
        >
          Reload page
        </button>
        <Link to="/in/home" className={buttonClasses({ kind: "primary" })}>
          Go to home
        </Link>
      </div>
    </div>
  );
}
